import { rootSlice } from "../createRootSlice";
import { muiDataGridStarted } from "../apiutils";
const USERGROUP_BASE = "usergroups";
const API_TAG = "Usergroups";
const API_TAG_SINGLE = "UsergroupSingle";

export const usergroupSlice =  rootSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUsergroups: builder.query({
            query: ({ args, invalidate }) => ({
                url: `/${USERGROUP_BASE}?page=${args.page}&size=${args.size}`,
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: API_TAG }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getUsers', 'Usergroups')
        }),
        getUsergroup: builder.query({ 
            query: (id) => ({ 
                url: `/${USERGROUP_BASE}/${id}`, 
                method: 'GET', 
            }),
            providesTags: (id) => [{ type: API_TAG_SINGLE, id }],
        }),
        createUsergroup: builder.mutation({ 
            query: (user) => ({ 
                url: `/${USERGROUP_BASE}/create`, 
                method: 'POST', 
                body: user
            }),
            invalidatesTags: (user) => [
                { type: API_TAG }
            ],
        }),
        editUsergroup: builder.mutation({ 
            query: (user) => ({ 
                url: `/${USERGROUP_BASE}/${user.id}`, 
                method: 'PUT', 
                body: user
            }),
            invalidatesTags: (user) => [
                { type: API_TAG },
                { type: API_TAG_SINGLE, id: user.id }
            ],
        }),
        getUsergroupsSelect: builder.query({
            query: () => ({
                url: `/${USERGROUP_BASE}`,
                method: 'GET',
            }),
            providesTags: () => [{ type: API_TAG }],
        }),
        deleteUsergroup: builder.mutation({ 
            query: (id) => ({ 
                url: `/${USERGROUP_BASE}/${id}`, 
                method: 'DELETE', 
            }),
            invalidatesTags: (id) => [
                { type: API_TAG},
                { type: API_TAG_SINGLE, id }
            ],
        }),
    }),
    
});

export const { useGetUsergroupsQuery, useGetUsergroupQuery, useCreateUsergroupMutation, useEditUsergroupMutation, useGetUsergroupsSelectQuery, useDeleteUsergroupMutation} = rootSlice;
